var l11 = {
    code: 'bs',
    week: {
        dow: 1,
        doy: 7, // The week that contains Jan 1st is the first week of the year.
    },
    buttonText: {
        prev: 'Prošli',
        next: 'Sljedeći',
        today: 'Danas',
        year: 'Godina',
        month: 'Mjesec',
        week: 'Sedmica',
        day: 'Dan',
        list: 'Raspored',
    },
    weekText: 'Sed',
    allDayText: 'Cijeli dan',
    moreLinkText(n) {
        return '+ još ' + n;
    },
    noEventsText: 'Nema događaja za prikazivanje',
};

export { l11 as default };
